import React from "react";
import {action, computed, observable} from "mobx";
import uuidv4 from 'uuid/v4';

export interface WidgetModelInterface {
    key?: string;
    data: {};
    config: {
        type: string,
        displayName: string,
    };
    isSelected: boolean,
}

class Widget {

    key: string;

    @observable isSelected = false;

    @observable config: any = {};

    @observable data: any = {};

    private templateComponent: any;

    private editorComponent: any;

    constructor({
                    config = {
                        type: 'Logo',
                        displayName: 'Logo'
                    },
                    data = {},
                    key = uuidv4(),
                    isSelected = false
                }: WidgetModelInterface) {
        this.config = config;
        this.data = data;
        this.key = key;
        this.isSelected = isSelected;
    }

    @computed get displayName(): string {
        return this.config.displayName;
    }

    @action updateWidgetData = (data: any) => {
        this.data = data;
    };

    setEditorComponent(editorComponent: any) {
        this.editorComponent = editorComponent;
    }

    setTemplateComponent(templateComponent: any) {
        this.templateComponent = templateComponent;
    }

    renderEditor = (props = {}) => {
        const Component = this.editorComponent;

        props = {...props, ...this.data};

        return (<Component {...props}/>);
    };

    renderTemplate = (props = {}) => {
        const Component = this.templateComponent;

        props = {...props, ...this.data};

        return (<Component {...props}/>);
    };

    get asJson() {
        return {
            config: this.config,
            data: this.data,
            key: this.key,
            // isSelected: this.isSelected,
        };
    }

    renderButton = () => {
        return (<div>Add button</div>);
    }

}

export default Widget;
